// extracted by mini-css-extract-plugin
export default {"scroll":"TableWrapper_scroll__+FV2U","tableWrapper":"TableWrapper_tableWrapper__5o8w6","tableWrapper__transparent":"TableWrapper_tableWrapper__transparent__Ei7Nh"};